import React, { useEffect, useState } from 'react'
import './cu-associates.scss'
import NormalInput from '../../common/inputs/NormalInput'
import SelectInput from '../../common/inputs/SelectInput'
import { associatesTypes } from '../../../assets/javascript/const-data'
import { customerAxios, staffAxios } from '../../../config/axios'
import toast from 'react-hot-toast'

const CUAssociates = ({ currentData, setModal, setData }) => {
    const [assTypes, setAssType] = useState([])
    const [form, setForm] = useState({})
    const [staffList, setStaffList] = useState([])
    const [workerType, setWorkerType] = useState([])
    const [workerSubType, setWorkerSubType] = useState([])

    const handleChange = (e) => {

        if (e.target.name === 'asot_type') {
            setForm({
                asot_type: e.target.value
            })
            return
        }

        setForm({
            ...form,
            [e.target.name]: e.target.value
        })
    }

    const handleSubmit = (e) => {
        e.preventDefault();
        if (currentData) {
            customerAxios.put('/associate', { ...form, asot_id: currentData?.asot_id }).then(() => {
                setModal({ status: false })
                setData((state) => state?.map((asot) => {
                    if (asot?.asot_id === currentData?.asot_id) {
                        return {
                            ...asot,
                            first_name: form?.first_name,
                            last_name: form?.last_name,
                            address: {
                                address: form?.address,
                                place: form?.place,
                                city: form?.city,
                                pin_code: form?.pin_code,
                                district: form?.district,
                                state: form?.state
                            },
                            business: {
                                company_name: form?.company_name,
                                web_link: form?.web_link,
                            },
                            primary_number: { country_code: '91', number: form?.primary_number },
                            secondary_number: { number: form?.secondary_number },
                            whatsapp_number: { number: form?.whatsapp_number },
                            staff_id: form?.staff_id,
                            cid: [form?.cid],
                            worker_type: form?.worker_type,
                            worker_sub_type: form?.worker_sub_type
                        }
                    }
                    return asot
                }))
            }).catch((error) => {
                toast.error(error.message)
            })
        } else {
            // Create new associate
            customerAxios.post('/associate', form).then((response) => {
                setModal({ status: false })
                setData((state) => ([response.data, ...state]))
            }).catch((error) => {
                toast.error(error.message)
            })
        }
    }

    useEffect(() => {
        // associate types
        setAssType(['Person', 'Non person', 'Owner'].map((value) => ({ option: value, value, selected: currentData?.asot_type === value })))

        // StaffList 
        staffAxios.get('/admin/staff/all-list?nameOnly=Yes').then((response) => {
            setStaffList(response?.data?.map((obj) => ({ option: obj?.full_name, value: obj?._id, selected: currentData?.staff_id === obj?._id })))
        })

        // Worker Type
        setWorkerType(associatesTypes?.map((obj) => ({ option: obj?.item, value: obj?.item, selected: obj?.item === currentData?.worker_type })))

        setForm({
            asot_type: currentData?.asot_type,
            asot_id: currentData?.asot_id,
            first_name: currentData?.first_name,
            last_name: currentData?.last_name,
            address: currentData?.address?.address,
            place: currentData?.address?.place,
            city: currentData?.address?.city,
            pin_code: currentData?.address?.pin_code,
            district: currentData?.address?.district,
            state: currentData?.address?.state,
            company_name: currentData?.business?.company_name,
            web_link: currentData?.business?.web_link,
            primary_number: currentData?.primary_number?.number,
            secondary_number: currentData?.secondary_number?.number,
            whatsapp_number: currentData?.whatsapp_number?.number,
            staff_id: currentData?.staff_id,
            cid: currentData?.cid?.[0],
            worker_type: currentData?.worker_type,
            worker_sub_type: currentData?.worker_sub_type
        })

        // eslint-disable-next-line
    }, [])

    useEffect(() => {
        if (form?.worker_type) {
            associatesTypes.map((obj) => {
                if (obj.item === form.worker_type) {
                    setWorkerSubType(obj?.sub_items?.map((sub) => ({ option: sub.item, value: sub.item, selected: sub.item === form?.worker_sub_type })))
                }
                return obj
            })
        }
    }, [form])

    return (
        <div className="cu-associates-sub-div">
            <form action="" onSubmit={handleSubmit}>
                <div className="input-group-div">
                    {!form?.asot_type && <SelectInput label='Associate type*' name='asot_type' values={assTypes} onChangeFun={handleChange}
                        firstOption={{ option: 'Choose...', value: '' }} />}
                    {(form?.asot_type === 'Person') && <>
                        <NormalInput label='First name*' name='first_name' value={form?.first_name} onChangeFun={handleChange} />
                        <NormalInput label='Last name*' name='last_name' value={form?.last_name} onChangeFun={handleChange}
                            isRequired={form?.asot_type === 'Person'} />
                    </>}
                    {(form?.asot_type === 'Non person' || form?.asot_type === 'Owner') && <>
                        <NormalInput label='Title*' name='first_name' value={form?.first_name} onChangeFun={handleChange} />
                    </>}
                    {form?.asot_type === 'Person' && <>
                        <NormalInput label='Address' name='address' value={form?.address} onChangeFun={handleChange}
                            isRequired={false} />
                        <NormalInput label='Place*' name='place' value={form?.place} onChangeFun={handleChange} />
                        <NormalInput label='City' name='city' value={form?.city} onChangeFun={handleChange} isRequired={false} />
                        <NormalInput label='Pin code' name='pin_code' value={form?.pin_code} onChangeFun={handleChange}
                            isRequired={false} type={'number'} />
                        <NormalInput label='District' name='district' value={form?.district} onChangeFun={handleChange}
                            isRequired={false} />
                        <NormalInput label='State' name='state' value={form?.state} onChangeFun={handleChange}
                            isRequired={false} />
                    </>}
                    {(form?.asot_type === 'Person' || form?.asot_type === 'Non person') && <>
                        <NormalInput label='Company name' name='company_name' value={form?.company_name} onChangeFun={handleChange}
                            isRequired={false} />
                    </>}
                    {form?.asot_type === 'Non person' && <>
                        <NormalInput label='Web link' type={'url'} name='web_link' value={form?.web_link} onChangeFun={handleChange}
                            isRequired={false} />
                    </>}
                    {form?.asot_type === 'Person' && <>
                        <NormalInput label='Primary number (IN)*' type={'number'} name='primary_number' value={form?.primary_number} onChangeFun={handleChange}
                            min={'5000000000'} max={'9999999999'} />
                        <NormalInput label='Secondary number' type={'number'} name='secondary_number' value={form?.secondary_number} onChangeFun={handleChange}
                            isRequired={false} />
                        <NormalInput label='Whatsapp number' type={'number'} name='whatsapp_number' value={form?.whatsapp_number} onChangeFun={handleChange}
                            isRequired={false} />

                        <SelectInput label='Staff' name='staff_id' values={staffList} onChangeFun={handleChange}
                            firstOption={{ option: 'Choose...', value: '' }} isRequired={false} />
                        <NormalInput label='Customer ID' type={'number'} name='cid' value={form?.cid} onChangeFun={handleChange}
                            isRequired={false} />
                    </>}
                    {(form?.asot_type === 'Person' || form?.asot_type === 'Non person') && <>
                        <SelectInput label='Worker type' name='worker_type' values={workerType} onChangeFun={handleChange}
                            firstOption={{ option: 'Choose...', value: '' }} isRequired={false} />
                        <SelectInput label='Worker Sub Type' name='worker_sub_type' values={workerSubType} onChangeFun={handleChange}
                            firstOption={{ option: 'Choose...', value: '' }} isRequired={false} />
                    </>}
                </div>
                <button>Submit</button>
            </form>
        </div>
    )
}

export default CUAssociates